<template>
  <VContainer
    class="py-10"
    fluid
  >
    <VRow>
      <VCol
        class="pb-0"
        cols="12"
        lg="12"
        md="12"
        sm="12"
        xs="12"
      >
        <h1 class="heading-3 textPrimary--text">
          {{ title }}
        </h1>
      </VCol>
      <VCol
        class="pb-0 pt-6"
        cols="12"
        lg="12"
        md="12"
        sm="12"
        xs="12"
      >
        <VueMarkdown
          v-if="description"
          :key="descriptionKey"
          class="body-2 textPrimary--text"
        >
          {{ description }}
        </VueMarkdown>
      </VCol>
      <VCol
        class="pb-0 pt-3"
        cols="12"
        lg="12"
        md="12"
        sm="12"
        xs="12"
      >
        <span class="heading-6 textPrimary--text">
          {{ subTitle }}
        </span>
      </VCol>
    </VRow>
    <CommuneGroup
      class="pt-8 mt-0"
      :communesList="communesList"
    />
  </VContainer>
</template>

<script lang="ts">
import { getMetaInfo } from '@/utils/seo';

export default {
  name: 'NightCardPage',
  metaInfo() {
    return getMetaInfo((this as { seo?: unknown }).seo);
  },
};
</script>

<script setup lang="ts">
import { ref } from 'vue';
import VueMarkdown from 'vue-markdown';
import CommuneGroup from '@/components/nightCard/CommuneGroup.vue';
import { getNightCardPage, getCommunes } from '@/services/cmsService';
import { useStore, useCmsLocaleReload } from '@/composables';

const store = useStore();
const title = ref('');
const description = ref('');
const descriptionKey = ref(new Date().toString());
const subTitle = ref('');
const communesList = ref<any[]>([]);
const seo = ref<any>('');

async function getNightCardPageAPI() {
  const data = await getNightCardPage() as any;
  seo.value = data.Seo;
  title.value = data.Title;
  subTitle.value = data.Subtitle;
  description.value = data.Description;
  descriptionKey.value = new Date().toString();
}

async function getNightCardListAPI() {
  communesList.value = await getCommunes() as any;
}

async function loadCmsData() {
  try {
    store.commit('common/setGlobalLoading', true);
    await getNightCardPageAPI();
    await getNightCardListAPI();
  } catch (e) {
    // to-do rethink about catch
  }
  store.commit('common/setGlobalLoading', false);
}

useCmsLocaleReload(loadCmsData);
</script>

<style scoped>

</style>
